import { FETCH_CU_MTD_PRODUCTION } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_CU_MTD_PRODUCTION:
			return action.payload;

		default:
			return state;
	}
};
